import React, { useEffect } from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    formWrapper: {
        width: '100%',
        maxWidth: '600px',
        backgroundColor: 'rgba(34, 34, 34, 0.20)',
        backdropFilter: 'blur(10px)',
        borderRadius: '16px',
        padding: '24px',
        textAlign: 'left',
        '@media (min-width: 501px)': {
            minWidth: '450px',
        },
        '@media (max-width: 768px)': {
            maxWidth: '100%',
            padding: '20px 16px',
            textAlign: 'left',
        },
    },

    hubspotFormContainer: {
        width: '100%',
        // HubSpot raw HTML form styling
        '& .hsfc-Step__Content': {
            padding: '0 !important',
            margin: '0',
        },
        '& .hsfc-Row': {
            marginBottom: '12px',
            display: 'flex',
            gap: '12px',
            '@media (max-width: 768px)': {
                flexDirection: 'column',
                gap: '8px',
            },
        },
        '& .hsfc-TextField, & .hsfc-EmailField': {
            flex: '1',
            minWidth: '0',
        },
        '& .hsfc-FieldLabel': {
            fontFamily: 'Figtree, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            color: '#F4F0E7 !important',
            fontSize: '13px',
            fontWeight: '500',
            marginBottom: '6px',
            display: 'block',
        },
        '& .hsfc-FieldLabel span': {
            color: '#F4F0E7 !important',
        },
        '& .hsfc-FieldLabel__RequiredIndicator': {
            color: '#F4F0E7 !important',
        },
        '& .hsfc-TextInput': {
            fontFamily: 'Figtree, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '8px',
            padding: '10px 12px',
            color: '#222222',
            width: '100%',
            boxSizing: 'border-box',
            fontSize: '14px',
        },
        '& .hsfc-TextInput:focus': {
            outline: 'none',
            border: '1px solid #C9A774',
        },
        '& .hsfc-TextInput::placeholder': {
            color: 'rgba(34, 34, 34, 0.5)',
        },
        '& .hsfc-NavigationRow': {
            marginTop: '0 !important',
            padding: '0',
        },
        '& .hsfc-NavigationRow__Buttons': {
            padding: '0',
        },
        '& .hsfc-Button': {
            fontFamily: 'Figtree, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            backgroundColor: '#C6A972 !important',
            color: '#222222 !important',
            border: 'none',
            borderRadius: '50px !important',
            padding: '14px 20px !important',
            fontSize: '14px !important',
            fontWeight: '700 !important',
            letterSpacing: '0 !important',
            textTransform: 'uppercase',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            width: '100%',
        },
        '& .hsfc-Button:hover': {
            backgroundColor: '#B8966A !important',
            transform: 'translateY(-2px)',
        },
        '& .hsfc-ErrorAlert': {
            fontFamily: 'Figtree, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            color: '#ff6b6b',
            fontSize: '11px',
            marginTop: '4px',
        },
        '& .hsfc-RichText': {
            color: '#F4F0E7 !important',
        },
        '& .hsfc-RichText p': {
            color: '#F4F0E7 !important',
        },
        '& .hsfc-RichText strong': {
            color: '#F4F0E7 !important',
        },
    },
});

interface AlyzeHubSpotFormProps {
    portalId: string;
    formId: string;
    region?: string;
    transparentBackground?: boolean;
}

export const AlyzeHubSpotForm: React.FC<AlyzeHubSpotFormProps> = ({
    portalId,
    formId,
    region = 'na2',
    transparentBackground = false,
}) => {
    const styles = useStyles();

    useEffect(() => {
        const script = document.createElement('script');
        script.src = `https://js-${region}.hsforms.net/forms/embed/developer/${portalId}.js`;
        script.defer = true;
        
        document.body.appendChild(script);

        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, [portalId, region]);

    return (
        <div className={styles.formWrapper} style={transparentBackground ? { backgroundColor: 'transparent', padding: '0', backdropFilter: 'none' } : undefined}>
            <div className={styles.hubspotFormContainer}>
                <div 
                    className="hs-form-html" 
                    data-region={region}
                    data-form-id={formId}
                    data-portal-id={portalId}
                />
            </div>
        </div>
    );
};
